/**
 * This script will allow for the following:
 * - desktop navigation can hover over drop down items
 * - desktop top level items (with drop downs) click through to their respective pages
 * - mobile (under BREAKPOINT) can toggle drop down items
 * - mobile can still click through to sub-pages but cannot click through to top level pages with drop downs
 *
 * Overall was inspired by various sources online and then customized to our needs, particularly around
 * the mobile behaviour
 *
 * @author Dan Klassen <dan@triplei.ca>
 */
document.addEventListener("DOMContentLoaded", function () {
    const BREAKPOINT = 1400;
    const hoverIntentDelay = 50;
    const hoverLeaveDelay = 200;
    let enterStartTime = null;
    let leaveStartTime = null;
    let enterFrameId, leaveFrameId;

    // Add padding to ccm-page if we're using the fixed bar.
    const $navbar = $('.ccm-block-top-navigation-bar .navbar')
    const $transparentNavbar = $('div[data-transparency=navbar]')
    if ($navbar.hasClass('fixed-top')) {
        if ($transparentNavbar.length === 0 || !$transparentNavbar.hasClass('transparency-enabled')) {
            $('.ccm-page').css('padding-top', $navbar.outerHeight())
        }
    }

    // Bootstrap makes top level drop down items not clickable - we want to override that
    document.querySelectorAll('.navbar .nav-item a.nav-link').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            window.location = this.href;
        });
    });

    if (window.innerWidth > BREAKPOINT) {
        document.querySelectorAll('.navbar .nav-item').forEach(function (item) {
            // bootstrap 5 makes drop down items only show on click - we want them to show / hide on hover
            item.addEventListener('mouseover', function (e) {
                const linkElm = this.querySelector('a[data-bs-toggle]');
                if (linkElm === null) {
                    return;
                }

                if (leaveFrameId) {
                    cancelAnimationFrame(leaveFrameId);
                    leaveFrameId = null;
                }
                enterStartTime = performance.now()
                const checkEnter = (time) => {
                    if (time - enterStartTime > hoverIntentDelay) {

// Ensure no other navigation items are showing by removing the 'show' class from all dropdown-related elements
                        document.querySelectorAll('.navbar .nav-item .dropdown-menu, .navbar .nav-item a[data-bs-toggle], .navbar .nav-item').forEach(function (navItem) {
                            navItem.classList.remove('show');
                        });
                        const subMenu = item.querySelector('.dropdown-menu');
                        linkElm.classList.add('show');
                        subMenu.classList.add('show');
                        item.classList.add('show');

                        // if we are showing the mega-menu it is too wide and ends up running off the screen - let's try to change that
                        if (linkElm.classList.contains('mega-three-column')) {
                            // Check the bounding box of the dropdown menu
                            const bounding = subMenu.getBoundingClientRect();
                            const viewportWidth = window.innerWidth;

                            // If the dropdown menu is going off the screen adjust it
                            if (bounding.right > viewportWidth) {
                                const overflow = bounding.right - viewportWidth;
                                subMenu.style.left = `-${overflow + 50}px`;
                            }

                        }

                        return;
                    }
                    enterFrameId = requestAnimationFrame(checkEnter);
                }
                enterFrameId = requestAnimationFrame(checkEnter);


            });
            item.addEventListener('mouseleave', function (e) {
                const linkElm = this.querySelector('a[data-bs-toggle]');
                if (linkElm === null) {
                    return;
                }

                if (enterFrameId) {
                    cancelAnimationFrame(enterFrameId);
                    enterFrameId = null;
                }

                leaveStartTime = performance.now();
                const checkLeave = (time) => {
                    if (time - leaveStartTime > hoverLeaveDelay) {
                        const subMenu = item.querySelector('.dropdown-menu');
                        linkElm.classList.remove('show');
                        subMenu.classList.remove('show');
                        item.classList.remove('show');
                        return
                    }
                    leaveFrameId = requestAnimationFrame(checkLeave);
                }
                leaveFrameId = requestAnimationFrame(checkLeave);
            });
        });

    } else {
        // mobile items should go here
        document.querySelectorAll('.navbar .nav-item .dropdown-arrow').forEach(function (item) {
            // we want to make the drop arrows toggle the sub-navigation on touch on small screens
            item.addEventListener('click', function (e) {
                e.preventDefault();
                const arrow = this;
                const listItem = arrow.parentNode;

                if (listItem.classList.contains('show')) {
                    listItem.classList.remove('show');
                } else {
                    listItem.classList.add('show');
                }
            });
        });
    }
});
